import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import "./styles/BranchPage.css";

import logo from "/assets/logo.svg";
import ProfileIcon from "/assets/avatar_face_man_boy_profile_smiley_happy_people_icon_181659.png";
import ArrowDown from "/assets/ArrowDown.svg";

const Branch = () => {
  const [userName, setUserName] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [branchDropdownOpen, setBranchDropdownOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branches, setBranches] = useState([]);
  const [permissions, setPermissions] = useState(null);
  const [profileImage, setProfileImage] = useState(ProfileIcon);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    if (userData) {
      setUserName(userData.name || "");
      setIsAdmin(userData.admin === "true");
      const branchNames = userData.branch_names || "";
      setBranches(branchNames.split(","));
      fetchAvatar(userData.id);
    }
  }, []);

  const fetchAvatar = async (userId) => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/user/${userId}/avatar`,
        {
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const imageUrl = URL.createObjectURL(response.data);
        setProfileImage(imageUrl);
      }
    } catch (error) {
      console.error("Error fetching avatar:", error);
    }
  };

  const toggleBranchDropdown = () => {
    setBranchDropdownOpen(!branchDropdownOpen);
    if (!branchDropdownOpen) {
      setSearchTerm("");
      setErrorMessage("");
    }
  };
  const handleBranchSelect = (branch) => {
    const trimmedBranch = branch.trim(); // ลบช่องว่างข้างหน้าและข้างหลังของชื่อสาขา
    console.log(`Selected branch: ${trimmedBranch}`); // Log ว่าเลือกสาขาอะไร
    setSelectedBranch(trimmedBranch);
    setBranchDropdownOpen(false);
    setErrorMessage("");
  };

  const handleOkButtonClick = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (selectedBranch) {
      setLoading(true);

      try {
        const userData = JSON.parse(sessionStorage.getItem("userData"));
        const userId = userData.id;

        // Encode the branch name to handle special characters
        const encodedBranch = encodeURIComponent(selectedBranch);

        const response = await axios.get(
          `${
            import.meta.env.VITE_API_URL
          }/permissions/${userId}/${encodedBranch}`
        );

        if (response.data.length > 0) {
          const permissionsData = {
            page_dashboard: response.data[0].page_dashboard,
            page_alert: response.data[0].page_alert,
            page_weather: response.data[0].page_weather,
            page_lighting: response.data[0].page_lighting,
            page_gis: response.data[0].page_gis,
            page_camera: response.data[0].page_camera,
            page_display: response.data[0].page_display,
          };

          setPermissions(permissionsData);
          sessionStorage.setItem(
            "permissions",
            JSON.stringify(permissionsData)
          );

          const destination = isAdmin ? "/main" : "/dashboard";
          sessionStorage.setItem("selectedBranch", selectedBranch);

          document.title += ` - ${selectedBranch}`;

          setTimeout(() => {
            setLoading(false);
            navigate(destination);
          }, 1000); // Delay navigation by 1 second
        } else {
          setLoading(false);
          setErrorMessage("ไม่มีสิทธิ์เข้าถึงสาขานี้");
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching permissions:", error);
        setErrorMessage("เกิดข้อผิดพลาดในการดึงข้อมูลสิทธิ์");
      }
    } else {
      setErrorMessage("กรุณาเลือกสาขาก่อน");
    }
  };

  return (
    <div className="background-image">
      <div className="container">
        <form className="login-form">
          <div className="logo">
            <img src={logo} alt="Logo" style={{ marginRight: "8px" }} />
          </div>
          <h2>เข้าสู่ระบบ</h2>
          <div className="nameUser">
            <img
              src={profileImage}
              alt="Profile"
              className="profile-pictureBranch"
              onError={(e) => {
                e.target.src = ProfileIcon; // ใช้รูป default ถ้าโหลดไม่สำเร็จ
              }}
            />
            {userName && <span className="nameBranch">{userName}</span>}
            {isAdmin ? (
              <span className="adminBranch">เจ้าหน้าที่ดูแลระบบ</span>
            ) : (
              <span className="adminBranch">ผู้ใช้งาน</span>
            )}
          </div>

          <div
            className={`dropdown ${branchDropdownOpen ? "clicked" : ""} ${
              selectedBranch ? "selected" : ""
            }`}
            onClick={toggleBranchDropdown}
          >
            <a>
              {selectedBranch || "เลือกสาขา"}
              <img
                className={`arrow-icon-branch ${
                  branchDropdownOpen ? "rotate" : ""
                }`}
                src={ArrowDown}
                alt="Arrow"
              />
            </a>
            {branchDropdownOpen && (
              <div className="dropdown-content">
                <div className="search-container">
                  <input
                    type="text"
                    placeholder="ค้นหาสาขา..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
                <div className="branch-list">
                  {branches
                    .filter((branch) =>
                      branch.toLowerCase().includes(searchTerm.toLowerCase())
                    )
                    .map((branch, index) => (
                      <div
                        key={index}
                        onClick={() => handleBranchSelect(branch)}
                      >
                        <li>{branch}</li>
                      </div>
                    ))}
                  {branches.filter((branch) =>
                    branch.toLowerCase().includes(searchTerm.toLowerCase())
                  ).length === 0 && (
                    <div className="no-results-branch">
                      ไม่พบสาขาที่ตรงกับคำค้นหา
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          {errorMessage && (
            <div
              style={{
                color: "#F2274C",
                marginTop: "10px",
                textAlign: "center",
                width: "100%",
                animation: "0.3s ease-out 0s 1 slideUp",
                "@keyframes slideUp": {
                  from: {
                    opacity: 0,
                    transform: "translateY(10px)",
                  },
                  to: {
                    opacity: 1,
                    transform: "translateY(0)",
                  },
                },
              }}
            >
              {errorMessage}
            </div>
          )}
          <Button
            className="ok-branch"
            variant="contained"
            type="submit"
            onClick={handleOkButtonClick}
            sx={{
              marginTop: 2,
              fontFamily: '"IBM Plex Sans Thai", sans-serif',
              boxShadow: "none", // Removes the shadow
              ":hover": {
                backgroundColor: "#3f51b5", // Custom hover background color
                boxShadow: "none", // Ensures no shadow on hover
              },
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "ตกลง"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Branch;
